import { render } from "./InventoryTarget.vue?vue&type=template&id=5940a14e"
import script from "./InventoryTarget.vue?vue&type=script&lang=js"
export * from "./InventoryTarget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__